import { render, staticRenderFns } from "./PanelInvoiceDownloadModal.vue?vue&type=template&id=0f753139&scoped=true&"
import script from "./PanelInvoiceDownloadModal.vue?vue&type=script&lang=ts&"
export * from "./PanelInvoiceDownloadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f753139",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QTable,QTd});
